import './App.css';
import {Route, Routes, useLocation} from 'react-router-dom';
import {NotificationContainer} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import AccountActivationPage from "./pages/AccountActivationPage";
import LoginPage from "./pages/LoginPage";
import ParolaUitataPage from "./pages/ParolaUitataPage";
import HomePage from "./pages/HomePage";
import ExpozitiePublicPage from "./pages/ExpozitiePublicPage";
import ExpozitiiListPage from "./pages/ExpozitiiListPage";
import LucrarePublicPage from "./pages/LucrarePublicPage";
import ArtistPublicPage from "./pages/ArtistPublicPage";
import ArtistiListPage from "./pages/ArtistiListPage";
import React, {useEffect} from "react";
import {hideSplash, waitsForData} from "./splash";
import ProtectedRoute from "./components/ProtectedRoute";
import ContactPage from "./pages/ContactPage";
import NftPage from "./pages/NftPage";
import CookieNotice from "./components/CookieNotice";

import PublicLayout from "./components/PublicLayout";

// react-admin se incarca separat (chunk propriu), doar cand se intra pe /admin -
// vizitatorii partii publice nu descarca react-admin.
const AdminApp = React.lazy(() => import("./reactAdmin/AdminApp"));

function App() {
    // Ecranul de încărcare (src/splash.js): paginile fără date de așteptat (panou, login...) îl ascund acum.
    const {pathname} = useLocation();
    useEffect(() => {
        if (!waitsForData(pathname)) hideSplash();
    }, [pathname]);
    return (
        <>
        <Routes>
            {/* Public - fara autentificare */}
            <Route element={<PublicLayout />} >
                <Route path="/" element={<HomePage/>}/>
                <Route path="/nft" element={<NftPage />}/>
                <Route path="/activare-cont" element={<AccountActivationPage />} />
                <Route path="/resetare-parola" element={<AccountActivationPage />} />
                <Route path="/parola-uitata" element={<ParolaUitataPage />} />
                <Route path="/login" element={<LoginPage />}/>
                <Route path="/expozitii" element={<ExpozitiiListPage/>}/>
                <Route path="/expozitii/:slug" element={<ExpozitiePublicPage/>}/>
                <Route path="/artisti" element={<ArtistiListPage/>}/>
                <Route path="/colectionari" element={<ArtistiListPage type="colectionar"/>}/>
                {/* ADR-0001: membrul si lucrarile lui sub prefixul tipului (artist / colectionar). */}
                <Route path="/artisti/:membru" element={<ArtistPublicPage type="artist"/>}/>
                <Route path="/artisti/:membru/lucrari/:slug" element={<LucrarePublicPage type="artist"/>}/>
                <Route path="/colectionari/:membru" element={<ArtistPublicPage type="colectionar"/>}/>
                <Route path="/colectionari/:membru/lucrari/:slug" element={<LucrarePublicPage type="colectionar"/>}/>
                <Route path="/contact" element={<ProtectedRoute component={ContactPage}/>}/>
            </Route>


            {/* react-admin - singura zona de management (admini + artisti) */}
            <Route path="/admin/*" element={<React.Suspense fallback={null}><AdminApp/></React.Suspense>}/>
        </Routes>
        <NotificationContainer/>
        <CookieNotice/>
        </>
    );
}

export default App;
